import { render, staticRenderFns } from "./userAdminContactModal.vue?vue&type=template&id=ebf2af10&"
import script from "./userAdminContactModal.vue?vue&type=script&lang=js&"
export * from "./userAdminContactModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports